/** @jsx jsx */
import { jsx, css } from "@emotion/react";
import * as commonStyles from "../explorer/styles";

const containerCSS = ({ isTranslucid }) => css`
    display: flex;
    align-items: center;

    p {
        margin: 0 0 0 12px;
        font-weight: 400;
        font-size: 13px;
        line-height: 20px;
        color: ${isTranslucid ? "#7875f9" : "#999999"};
        transition: all 150ms ease-out;
    }

    strong {
        font-weight: 600;
        color: ${isTranslucid ? "#504cf3" : "#505050"};
        transition: all 150ms ease-out;
    }
`;
const buttonCSS = ({ isTranslucid }) => css`
    ${commonStyles.resetButton}

    height: 30px;
    border: 1px solid #d5d5d5;
    width: 30px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #505050;
    background-color: #d5d5d5;
    transition: all 150ms ease-out;

    &:first-of-type {
        margin-right: 8px;
    }

    i {
        font-size: 18px;
    }

    &:disabled {
        opacity: 0.5;
    }

    ${isTranslucid &&
        `
        color: #ffffff;
        background-color: #7875F9;
    `}
`;

function AtlasPaginationControls(props) {
    const { setCurrentPage, itemsPerPage, totalCount, currentPage, isTranslucid } = props;
    const isNextButtonDisabled = currentPage === Math.ceil(totalCount / itemsPerPage);
    const isPrevButtonDisabled = currentPage === 1;
    const startNumber = (currentPage - 1) * itemsPerPage + 1;
    const endNumber = isNextButtonDisabled ? totalCount : currentPage * itemsPerPage;

    return (
        <div css={containerCSS({ isTranslucid })}>
            <button
                css={buttonCSS({ isTranslucid })}
                type="button"
                disabled={isPrevButtonDisabled}
                onClick={() => setCurrentPage(currentPage - 1)}
            >
                <i className="trpr__icon-back"></i>
            </button>
            <button
                css={buttonCSS({ isTranslucid })}
                type="button"
                disabled={isNextButtonDisabled}
                onClick={() => setCurrentPage(currentPage + 1)}
            >
                <i className="trpr__icon-forward"></i>
            </button>
            <p>
                <strong>
                    {startNumber}-{endNumber}
                </strong>{" "}
                of {totalCount}
            </p>
        </div>
    );
}

export default AtlasPaginationControls;
